export default {
  showConfirmDialog(state, payload) {
    state.showConfirmDialog = payload;
  },
  confirmItem(state, payload) {
    state.confirmItem = payload;
  },
};
